import { httpClient } from '../http-client';
import {GET_POSTS, generateFullUrl} from './api-const';
import {
  FETCH_POST,
  _REQUEST,
  _SUCCESS,
  _ERROR,
  SEARCH_TERMS_CHANGE,
  MOBILE_SEARCH_TOGGLE,
  SEARCH,
  TOGGLE_MENU,
  OPEN_MOBILE_MODE,
  SHOW_SUBSCRIPTION_OVERLAY,
  HIDE_SUBSCRIPTION_OVERLAY,
  SUBSCRIBE,
  UPDATE_SUBSCRIPTION,
} from '../reducers/reducers-const';

function get(url, query, action, callback?) {
  return dispatch => {
    dispatch({
      type: `${action}${_REQUEST}`
    });

    const fullUrl = generateFullUrl(url, query);

    return httpClient.get(fullUrl, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json'
      }
    })
    .then(response => {
      if (callback) {
        callback(response.data);
      }

      return dispatch({
        type: `${action}${_SUCCESS}`,
        data: response.data
      });
    })
    .catch(error => dispatch({
      type: `${action}${_ERROR}`,
      error
    }));
  };
}

export const ACCOUNT_MANAGER_PARAM = 'account-manager';

let isAccountManagerMode: boolean = false;

export function setAccountMannagerMode(mode: boolean) {
  isAccountManagerMode = mode;
}

export function loadArticles(tag, page?, search?, callback?) {
  page = !page ? '' : page;
  search = !search ? '' : search;

  return get(
    GET_POSTS,
    {tag, page, search, ...(isAccountManagerMode && {[ACCOUNT_MANAGER_PARAM]: true})},
    FETCH_POST,
    callback);
}

export function updateSearch(searchTerms) {
  return {
    type: `${SEARCH_TERMS_CHANGE}`,
    data: searchTerms
  };
}

export function hasResults(mode) {
  return {
    type: `${MOBILE_SEARCH_TOGGLE}`,
    data: mode
  };
}

export function sending(mode) {
  return {
    type: mode ? `${SEARCH}${_REQUEST}` : `${SEARCH}${_SUCCESS}`,
    data: mode
  };
}

export function toggleMenu(state) {
  return {
    type: `${TOGGLE_MENU}`,
    data: state
  };
}

export function toggleMobileSearchForm(state) {
  return {
    type: `${OPEN_MOBILE_MODE}`,
    data: state
  };
}

export function showSubscriptionOverlay() {
  return {
    type: SHOW_SUBSCRIPTION_OVERLAY,
  };
}

export function hideSubscriptionOverlay() {
  return {
    type: HIDE_SUBSCRIPTION_OVERLAY,
  };
}

export const subscribe = () => ({type: SUBSCRIBE, subscribed: true});
export type Subscribe = ReturnType<typeof subscribe>;

export const updateSubscription = (subscibed) => ({type: UPDATE_SUBSCRIPTION, subscibed});
export type UpdateSubscription = ReturnType<typeof updateSubscription>;
